import { frontendURL } from 'dashboard/helper/URLHelper.js';
import EngagehubDashboard from './EngagehubDashboard.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/engagehub-dashboard'),
      name: 'engagehub_dashboard',
      meta: {
        permissions: ['administrator'],
      },
      component: EngagehubDashboard,
    },
  ],
};
